import { FeedCommentAnswers } from '@/pages/feed/feed-comment-answers';
import { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import useAuthorityLevel from '@/hooks/useAuthorityLevel';
import { useSession } from '@/hooks/useSession';
import { ProjectsContext } from './provider';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { PostActionsButton, PostActionsItem, PostActionsWrapper, PostComment, PostCommentBody, PostCommentContent, PostCommentHeader, PostCommentName, PostCommentText, PostCommentTime } from '@/components/custom/post';
import { AvatarWrapper } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { FiTrash2 } from 'react-icons/fi';

export function ProjectsCardComment({ comment, comments, onDelete }) {
  const { session } = useSession();
  const client = useClient();
  const authorityLevel = useAuthorityLevel(session);
  const { selectedProject } = useContext(ProjectsContext);
  const [isOpenAnswer, setIsOpenAnswer] = useState(false);
  const [answers, setAnswers] = useState([]);

  const findAnswers = () => {
    const commentsWithAnswers = comments?.filter(comment => comment?.['comment-parent-id'] !== null);
    const answersByCommentId = commentsWithAnswers?.filter(item => item?.['comment-parent-id'] === comment?.id);

    setAnswers(answersByCommentId);
  };

  const handleCreateAnswer = async value => {
    try {
      const response = await client.mutate('/comments', {
        'comment-parent-id': comment.id,
        body: value,
        'project-version-id': comment['project-version-id']
      });

      setAnswers(prev => [response.data, ...prev]);
    } catch (error) {
      console.log(error);
      toast.error('Erro ao responder');
    }
  };

  const handleDeleteAnswer = async answerId => {
    const { error } = await client.delete(`/comments/${answerId}`);

    if (!error) {
      setAnswers(prev => prev.filter(item => item.id !== answerId));
    } else {
      console.log(error);
      toast.error('Erro ao deletar resposta');
    }
  };

  useEffect(() => {
    findAnswers();
  }, [comments]);

  return (
    <PostComment>
      <AvatarWrapper
        size="sm"
        src={comment?.user?.image?.url}
        text={comment?.user?.name}
      />

      <PostCommentContent>
        <PostCommentHeader>
          <PostCommentName>{(comment.user && comment.user.name) || 'Usuário do sistema'}</PostCommentName>
          <PostCommentTime>{moment(comment.created_at).fromNow()}</PostCommentTime>
        </PostCommentHeader>

        <PostCommentBody>
          <PostCommentText>{comment.body}</PostCommentText>
        </PostCommentBody>

        <FeedCommentAnswers
          answers={answers}
          onSubmit={handleCreateAnswer}
          isOpenAnswer={isOpenAnswer}
          onDelete={handleDeleteAnswer}
        />
      </PostCommentContent>

      <div className="flex flex-col gap-2 pt-8">
        <Button
          variant="link"
          size="xs"
          style={{ opacity: isOpenAnswer ? 0.5 : 1 }}
          onClick={() => setIsOpenAnswer(prev => !prev)}
        >
          Responder
        </Button>

        {(authorityLevel === 'admin' || comment.user?.id === session.user.id) && !selectedProject.approved && (
          <PostActionsWrapper>
            <PostActionsItem className="flex grow flex-row justify-end">
              <PostActionsButton
                isDanger
                onClick={() => onDelete(comment.id)}
                className="mr-0"
                aria-label="Excluir comentário"
              >
                <FiTrash2 size={16} />
              </PostActionsButton>
            </PostActionsItem>
          </PostActionsWrapper>
        )}
      </div>
    </PostComment>
  );
}
